/**
 * Audit Service
 * Handles API calls for RapID Audit operations
 */
const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:4000';
import { normalizeScanToken, SCAN_TOKEN_ERROR_MESSAGE } from '../constants/scan-token.constants';
export { normalizeScanToken };
import { buildApiError } from './api-error.service';
/**
 * Normalize barcode: trim, uppercase, validate format
 */
export function normalizeBarcode(barcode) {
    return normalizeScanToken(barcode);
}
/**
 * Scan animal by RapID tag barcode
 */
export async function scanAnimal(barcode, authToken) {
    // Normalize barcode
    const normalizedBarcode = normalizeBarcode(barcode);
    if (!normalizedBarcode) {
        throw new Error(SCAN_TOKEN_ERROR_MESSAGE);
    }
    const response = await fetch(`${API_BASE_URL}/api/audit/scan`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify({
            rapidTagBarcode: normalizedBarcode,
        }),
    });
    if (!response.ok) {
        throw await buildApiError(response);
    }
    return await response.json();
}
/**
 * Publish exception event
 */
export async function publishExceptionEvent(request, authToken) {
    const response = await fetch(`${API_BASE_URL}/api/audit/exception`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(request),
    });
    if (!response.ok) {
        throw await buildApiError(response);
    }
    return await response.json();
}
/**
 * Request cage lookup with cage number
 * Used when cage mismatch is detected to trigger cage audit for both cages
 */
export async function requestCageLookup(request, authToken) {
    const response = await fetch(`${API_BASE_URL}/api/audit/cage-lookup`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${authToken}`,
        },
        body: JSON.stringify(request),
    });
    if (!response.ok) {
        const error = await response.json();
        throw new Error(error.error || 'Failed to publish cage lookup event');
    }
    return await response.json();
}
//# sourceMappingURL=audit.service.js.map